<div class="navbar-header">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">  
        <a class="navbar-brand ml-5" href="#">
            <img src="https://cdn.iconscout.com/icon/free/png-512/koala-bear-lazy-honey-wild-animal-33903.png" width="60" height="60" alt="">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto w-100 justify-content-center">
            <li class="nav-item active">
            <a class="nav-link" href="#">Inicio <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#features">Características</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#team">Equipo</a>
            </li>
        </ul>
        <div *ngIf="!userLogged">
            <a class="btn btn-outline-success my-2 my-sm-0" href="login" role="button" style="float: left; margin: 10px;">Login</a>
        </div>
        <div *ngIf="!userLogged">
            <a class="btn btn-outline-success my-2 my-sm-0" href="register" role="button" style="float: left;">Register</a>
        </div>
        <div *ngIf="userLogged">
            <a class="btn btn-outline-success my-2 my-sm-0" href="dashboard" role="button" style="float: left; margin: 10px;">Dashboard</a>
        </div>
        <div *ngIf="userLogged">
            <a class="btn btn-outline-success my-2 my-sm-0" href="/" role="button" style="text-overflow:ellipsis; overflow: hidden; white-space: nowrap;" (click)="logout()">Cerrar sesion</a>
        </div>
        </div>
    </nav>
</div>